import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import axios from 'axios';
import { AiOutlineFileAdd } from 'react-icons/ai';
import {
  DropdownStyles,
  Logout,
  LogoutStyles,
  MenuIconStyles,
  TopBarStyles,
  IconStyles,
  TopInfo,
  NewOrderStyles,
} from './styles';
import HudsonLogo from '../../components/hudsonlogos-01.png';
import SearchBar from '../../components/SearchBar';
import { MenuIcon, PersonIcon, BellIcon, GreyBullet } from '../../components/icons';
import IconButton from '../../components/IconButton';
import LinkButton from '../../components/LinkButton';
import { useHistory } from 'react-router-dom';
import ToolTip from '../OrderEntry/ui/ToolTip';
import StagingBanner from '../../components/StagingBanner';
import ConfirmLeaveModal from '../OrderEntry/ConfirmLeaveModal';
import Settings from '../Settings';

interface Props {
  search: (searchText: string) => void;
  searchText: string;
  searchOpen: boolean;
  setSearchOpen: (searchOpen: boolean) => void;
  onSearchTextChange: (searchText: string) => void;
  name?: string;
  titleNumber?: string;
  orderId?: number;
  info?: boolean;
  closeSearch?: () => void;
  isTitleNumber?: boolean;
  showLeaveModal?: boolean;
}

const TopBar = (props: Props) => {
  const history = useHistory();
  // const [openDropdown, setOpenDropdown] = useState(false);
  const [openOptions, setOpenOptions] = useState(false);
  const [showHomeModal, setShowHomeModal] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [openSettingsPage, setOpenSettingsPage] = useState(false);

  useEffect(() => {
    window.addEventListener('click', () => {
      setOpenOptions(false);
    });
    return () => {
      window.removeEventListener('click', () => {
        setOpenOptions(false);
      });
    };
  }, []);
  const logout = async () => {
    await axios.post(`/api/clientaccount/logout`);
    history.push('/login');
  };
  const onHomeClick = () => {
    if (props.showLeaveModal) {
      setShowHomeModal(true);
    } else {
      history.push('/home');
    }
  };
  const onSearchEnter = () => {
    if (props.showLeaveModal) {
      setShowSearchModal(true);
    } else {
      props.search(props.searchText);
    }
  };
  const onLogoutClick = () => {
    if (props.showLeaveModal) {
      setShowLogoutModal(true);
    } else {
      logout();
    }
  };
  return (
    <>
      <TopBarStyles>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {showHomeModal && (
            <ConfirmLeaveModal
              onConfirmAction={() => history.push('/home')}
              buttonText="Leave"
              header="Leave Without Saving"
              info="Changes were made to a new order that were not yet saved. Leaving without saving will undo these changes."
              cancelButtonText="No, Take Me Back"
              onClose={() => setShowHomeModal(false)}
              open={showHomeModal}
            />
          )}
          {showSearchModal && (
            <ConfirmLeaveModal
              onConfirmAction={() => props.search(props.searchText)}
              buttonText="Leave"
              header="Leave Without Saving"
              info="Changes were made to a new order that were not yet saved. Leaving without saving will undo these changes."
              cancelButtonText="No, Take Me Back"
              onClose={() => setShowSearchModal(false)}
              open={showSearchModal}
            />
          )}
          {showLogoutModal && (
            <ConfirmLeaveModal
              onConfirmAction={() => logout()}
              buttonText="Leave"
              header="Leave Without Saving"
              info="Changes were made to a new order that were not yet saved. Leaving without saving will undo these changes."
              cancelButtonText="No, Take Me Back"
              onClose={() => setShowLogoutModal(false)}
              open={showLogoutModal}
            />
          )}
          <div onClick={onHomeClick} style={{ cursor: 'pointer' }}>
            <img src={HudsonLogo} style={{ width: 150, height: 62 }} alt="" />
          </div>
          {props.info && (
            <TopInfo>
              <div>{props.name}</div>
              {props.isTitleNumber && (
                <>
                  <GreyBullet style={{ margin: 8 }} />
                  <div>{props.titleNumber}</div>
                  <GreyBullet style={{ margin: 8 }} />
                  <div>{`HDS${props.orderId}`}</div>
                </>
              )}
            </TopInfo>
          )}
        </div>
        <div style={{ display: 'flex', cursor: 'pointer' }}>
          <SearchBar
            search={props.search}
            searchText={props.searchText}
            searchOpen={props.searchOpen}
            setSearchOpen={props.setSearchOpen}
            onSearchTextChange={props.onSearchTextChange}
            closeSearch={props.closeSearch}
            onEnterClick={onSearchEnter}
          />
          <div style={{ position: 'relative', display: 'flex', alignItems: 'center', marginLeft: 8 }}>
            <MenuIconStyles
              onClick={e => {
                e.stopPropagation();
                setOpenOptions(!openOptions);
              }}
            >
              <IconButton icon={<MenuIcon />} />
            </MenuIconStyles>
            <IconStyles>
              <div
                className="add_new_order_button"
                onClick={e => {
                  e.stopPropagation();
                  history.push('/new-order');
                }}
              >
                New Order
              </div>
              {/* <IconButton
                icon={<PersonIcon />}
                hoverColor="#ecf0f1"
                onClick={(e: MouseEvent) => {
                  e.stopPropagation();
                  setOpenOptions(!openOptions);
                }}
              /> */}
              <div
                onClick={e => {
                  e.stopPropagation();
                  history.push('/address-lookup');
                }}
                className="add_new_order_button"
              >
                Property Lookup
              </div>
              <div
                onClick={e => {
                  e.stopPropagation();
                  setOpenOptions(!openOptions);
                }}
                className="add_new_order_button"
              >
                Profile
              </div>
              {/* <IconButton icon={<BellIcon />} hoverColor='#f5f5f5' /> */}
            </IconStyles>
            {openOptions && (
              <Logout>
                <LogoutStyles
                  onClick={e => {
                    e.stopPropagation();
                    history.push('/settings/profile');
                  }}
                >
                  Settings
                </LogoutStyles>
                <LogoutStyles onClick={() => onLogoutClick()}>Log out</LogoutStyles>
                <NewOrderStyles
                  onClick={() => {
                    history.push('/new-order');
                  }}
                >
                  New Order
                </NewOrderStyles>
              </Logout>
            )}
          </div>
        </div>
      </TopBarStyles>
      <StagingBanner />
    </>
  );
};

export default TopBar;
